import {
  listen,
  menuConfigMessage,
  isMenuConfigRequestMessage,
  sendLocal,
} from "@sinch/bus";
import { useEffect } from "react";
import type { NavigationConfig } from "../components/NavigationBar/type";

export const useMenuConfigHandler = (menuConfig: NavigationConfig) => {
  useEffect(() => {
    sendLocal(menuConfigMessage(menuConfig)); //Always send event when menuConfig is set or updated
    const unsub = listen(() => {
      sendLocal(menuConfigMessage(menuConfig));
    }, isMenuConfigRequestMessage);

    return unsub;
  }, [menuConfig]);
};
